import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import FeatureDetailPage from './pages/FeatureDetailPage';
import MeditationPage from './pages/MeditationPage';
import MeditationDetailPage from './pages/MeditationDetailPage';
import GuidePage from './pages/GuidePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import InquiryPage from './pages/InquiryPage';
import InquiryDetailPage from './pages/InquiryDetailPage';
import FAQPage from './pages/FAQPage';
import SupportPage from './pages/SupportPage';
import ContactPage from './pages/ContactPage';
import ContactDetailPage from './pages/ContactDetailPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import { LegacySpreadRedirect } from './components/LegacySpreadRedirect';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/features/:id" element={<FeatureDetailPage />} />
        <Route path="/meditation" element={<MeditationPage />} />
        <Route path="/meditation/:id" element={<MeditationDetailPage />} />
        <Route path="/spreads" element={<Navigate to="/meditation" replace />} />
        <Route path="/spreads/:id" element={<LegacySpreadRedirect />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route path="/inquiry" element={<InquiryPage />} />
        <Route path="/inquiry/:slug" element={<InquiryDetailPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contact/:type" element={<ContactDetailPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
